import type { BulkUpdateAlfredDevicesResult } from "@/types/alfred-device"

export interface AlfredBulkUpdateFailureDetail {
  id: number
  deviceId: string
  clientId: string
  message: string
}

export interface AlfredBulkUpdateDeviceIdentity {
  deviceId: string
  clientId: string
}

export type AlfredBulkUpdatePresentation =
  | {
      kind: "success"
      variant: "success"
      title: string
    }
  | {
      kind: "partial"
      variant: "warning"
      title: string
      duration: number
    }
  | {
      kind: "failure"
      variant: "error"
      title: string
      duration: number
    }

export function getAlfredBulkUpdatePresentation(
  result: BulkUpdateAlfredDevicesResult,
): AlfredBulkUpdatePresentation {
  if (result.failureCount === 0) {
    return {
      kind: "success",
      variant: "success",
      title: `${result.successCount} device${result.successCount === 1 ? "" : "s"} updated`,
    }
  }

  const title = `${result.successCount} of ${result.requestedCount} devices updated`

  if (result.successCount > 0) {
    return {
      kind: "partial",
      variant: "warning",
      title,
      duration: Infinity,
    }
  }

  return {
    kind: "failure",
    variant: "error",
    title,
    duration: Infinity,
  }
}

export function getAlfredBulkUpdateFailureDetails(
  result: BulkUpdateAlfredDevicesResult,
  deviceIdentityByPrimaryKey: ReadonlyMap<number, AlfredBulkUpdateDeviceIdentity>,
): AlfredBulkUpdateFailureDetail[] {
  return result.failedDevices.map((failure) => {
    const identity = deviceIdentityByPrimaryKey.get(failure.id)
    return {
      id: failure.id,
      deviceId: identity?.deviceId ?? "Unknown device",
      clientId: identity?.clientId ?? "Unknown client",
      message: failure.message,
    }
  })
}
